import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CommandService, Reloadable } from '../../services/command/command.service';
import { CommandTemplate } from '../../entities/commandTemplate/commandTemplate';
import { Trigger } from '../../entities/trigger/trigger';

@Component({
  selector: 'app-trigger-table',
  templateUrl: './trigger-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TriggerTableComponent {
  private readonly commandService = inject(CommandService);

  readonly triggers = input.required<Trigger[]>();
  readonly reloadable = input<Reloadable>();

  onCommand(trigger: Trigger, command: CommandTemplate): void {
    this.commandService.execute(trigger, command, this.reloadable());
  }
}
